<template>
  <div class="row h-100">
    <div class="col-md-12">
      <dashboard-box class="pb-10 h-100">
        <template v-slot:preview>
          <data-table
              tableVariant="''"
              :hover="false"
              :outlined="false"
              :striped="false"
              :no-border-collapse="true"
              :borderless="true"
              :bordered="false"
              :items="formattedItems"
              :fields="fields"
              :perPage.sync="per_page"
              :page="page"
              :sortBy.sync="sort"
              :sortDesc.sync="order"
              :paginate="items"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import DataTable from "@/assets/components/dataTable/DataTable";
import inputFilter from "@/assets/components/filters/InputFilter";
import addButton from "@/assets/components/dataTable/AddButton";
import baseModule, {
  ERROR,
  LOADING,
  MODULE_NAME as BASE_MODULE,
  GET_HISTORIES,
  HISTORIES,
  BASE_URL
} from "@/core/services/store/service.module";
import store from "@/core/services/store";

const _BASE_MODULE = BASE_MODULE;

import {
  LARAVEL_DATE_TIME_FORMAT,
  MOMENT_SYSTEM_DATE_TIME_FORMAT
} from "@/core/config/constant";
import moment from "moment";

export default {
  name: "ServiceHistoryTable",
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_BASE_MODULE, baseModule);
  },
  props: {
    service_id: {
      required: true
    }
  },
  components: {
    DataTable,
    DashboardBox,
    inputFilter,
    addButton
  },
  computed: {
    error() {
      return store.getters[_BASE_MODULE + "/" + ERROR];
    },
    loading() {
      return store.getters[_BASE_MODULE + "/" + LOADING];
    },
    items() {
      return store.getters[_BASE_MODULE + "/" + HISTORIES];
    },
    filters() {
      return {
        per_page: this.per_page,
        page: this.page,
        search: this.search,
        order: this.order,
        sort: this.sort
      };
    },
    formattedItems() {
      let results = [];
      if (
          this.items === null ||
          this.items.data === null ||
          this.items.data === undefined
      )
        return [];

      this.items.data.forEach(item => {
        let createdAt = item.action_date
            ? moment(item.action_date, LARAVEL_DATE_TIME_FORMAT)
            : moment();
        results.push({
          id: item.id,
          service_status_id: item.service_status ? item.service_status.name : '-',
          user_id: item.user ? item.user.full_name : '-',
          related_person_id: item.related_person ? item.related_person.full_name : '-',
          description: item.description,
          customer_id: item.user ? item.user.full_name : '-',
          action_date: createdAt.format(MOMENT_SYSTEM_DATE_TIME_FORMAT)
        });
      });

      return results;
    }
  },
  data() {
    return {
      page: 1,
      per_page: 10,
      sort: "id",
      order: "desc",
      search: "",
      fields: [
        {
          key: "id",
          label: this.$t("services.id"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "service_status_id",
          label: this.$t("services.service_status"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "customer_id",
          label: this.$t("services.customer"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "related_person_id",
          label: this.$t("services.technician"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "description",
          label: this.$t("services.description"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        },
        {
          key: "action_date",
          label: this.$t("services.action_date"),
          sortable: true,
          class: "text-center border border-top-0 border-right-0 font-size-lg"
        }
      ],
      actionEdit: {
        key: "actions",
        label: this.$t("services.actions"),
        sortable: false,
        class: "text-center border border-top-0 border-right-0 font-size-lg"
      },
      actionView: {
        key: "actionView",
        label: this.$t("services.actions"),
        sortable: false,
        class: "text-center border border-top-0 border-right-0 font-size-lg"
      },
    };
  },
  methods: {
    filterResults() {
      if (this.loading) {
        return;
      }
      this.$store.dispatch(_BASE_MODULE + '/' + GET_HISTORIES, {
        filters: this.filters,
        url: BASE_URL + '/' + this.service_id + '/history'
      });
    },
    resetFilters() {
      this.search = "";
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t("general.dashboard"), route: "dashboard" },
      { title: this.$t("services.self") }
    ]);
    this.filterResults();
  },
  watch: {
    sort() {
      this.filterResults();
    },
    order() {
      this.filterResults();
    },
    per_page() {
      this.filterResults();
    }
  }
};
</script>

<style>
.filter-card {
  background: white;
  border-radius: 25px !important;
  padding: 20px;
}
</style>
